import { Component } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";

@Component({
    selector: "pl-skeleton",
    templateUrl: "./skeleton.component.html",
    styleUrls: ["./skeleton.component.scss"],
    standalone: false
})
export class SkeletonComponent {
  public tableDataSrc = new MatTableDataSource();
  public tableCols: string[] = [
    "name",
    "logon",
    "email",
    "role",
    "status",
    "actions",
  ];

  public skeletonData = Array.from(Array(10));
}
